<div class="modal-body">
	<div class="row">
		<div class="col-12 d-flex justify-content-between align-items-center">
			<p class="header-text poppins uppercase">TERMINATE GAME</p>
			<img src="assets/img/shared/close-icon.svg" class="close-icon pointer" alt="" (click)="close()">
		</div>
		<div class="col-12">
			<p class="sub-text">Update Game Details</p>
		</div>
	</div>
  
	<form [formGroup]="form"> 
		<div class="row">
			<div class="col-6 p-0">
				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline">
							<mat-label>Status</mat-label>
							<mat-select formControlName="status">
								<mat-option value="active">Active</mat-option>
								<mat-option value="complete">Complete</mat-option>
								<mat-option value="canceled">Canceled</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>

				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline" class="poppins">
							<mat-label>Player 1 Score</mat-label>
							<input matInput type="numeric" formControlName="score1">
						</mat-form-field>
					</div>
				</div>
		
				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline" class="poppins">
							<mat-label>Player 2 Score</mat-label>
							<input matInput type="numeric" formControlName="score2">
						</mat-form-field>
					</div>
				</div>

				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline" class="poppins">
							<mat-label>Player 1 Total Score</mat-label>
							<input matInput type="numeric" formControlName="total1">
						</mat-form-field>
					</div>
				</div>
		
				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline" class="poppins">
							<mat-label>Player 2 Total Score</mat-label>
							<input matInput type="numeric" formControlName="total2">
						</mat-form-field>
					</div>
				</div>
			</div>

			<div class="col-6 p-0">
				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline" class="poppins">
							<mat-label>Player 1 Score Margin</mat-label>
							<input matInput type="numeric" formControlName="margin1">
						</mat-form-field>
					</div>
				</div>
		
				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline" class="poppins">
							<mat-label>Player 2 Score Margin</mat-label>
							<input matInput type="numeric" formControlName="margin2">
						</mat-form-field>
					</div>
				</div>

				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline">
							<mat-label>Winner</mat-label>
							<mat-select formControlName="winType" (selectionChange)="selectWinner($event)" formControlName="winner">
								<mat-option value="{{item?.playerId}}" *ngFor="let item of players">{{ item?.playerName }}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>

				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline">
							<mat-label>Loser</mat-label>
							<mat-select formControlName="winType" (selectionChange)="selectLoser($event)" formControlName="loser">
								<mat-option value="{{item?.playerId}}" *ngFor="let item of players">{{ item?.playerName }}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>

				<div class="row">
					<div class="col-12">
						<mat-form-field appearance="outline">
							<mat-label>Win Type</mat-label>
							<mat-select formControlName="winType">
								<mat-option value="regular">Regular</mat-option>
								<mat-option value="default">Default</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>
			</div>
		</div>

		<div class="row mt-20">
			<div class="col-12 d-flex justify-content-center">
				<button class="btn create poppins" type="button" (click)="updateGame()">Update</button>  
			</div>
		</div>
	</form>
</div>  